import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const listItems = items.map((item, i) => ({
    ...item,
    position: i + 1,
  }));

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: listItems.map((item) => ({
      "@type": "ListItem",
      position: item.position,
      item: {
        "@id": item.to ? `https://bailu-model.com${item.to}` : "https://bailu-model.com",
        name: item.label,
      },
    })),
  };

  const categoryName = items.length >= 2 ? items[1]?.label : "";

  return (
    <nav aria-label="面包屑导航" className="py-3">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <ol className="flex items-center flex-wrap gap-1 text-xs text-foreground-500">
        {listItems.map((item, i) => (
          <li key={i} className="flex items-center gap-1">
            {i > 0 && (
              <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>
            )}
            {item.to ? (
              <Link
                to={item.to}
                className="hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700 font-medium whitespace-nowrap">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
      {categoryName && (
        <div className="mt-1">
          <h4 className="text-xs text-foreground-400">
            {categoryName}
            {categories.find((c) => c.name === categoryName)?.description
              ? ` - ${categories.find((c) => c.name === categoryName)?.description}`
              : ""}
          </h4>
        </div>
      )}
    </nav>
  );
}